// src/hooks/productTypes/useDeleteAllProductTypes.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllProductTypes as deleteAllProductTypesAPI } from "../../api/apiProductTypes";
import parseError from "../../utils/parseError";

const useDeleteAllProductTypes = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAll, isPending: isDeleteAll } = useMutation({
        mutationFn: deleteAllProductTypesAPI,
        onSuccess: (res) => {
            const message = res?.message || "Product types deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["productTypes"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete product types");
        },
    });

    return { deleteAllProductTypes: deleteAll, isDeleteAll };
};

export default useDeleteAllProductTypes;